import { baseAxiosConfig } from '@admin/api/config';
import axios from 'axios';

export const reggieClient = axios.create({
  baseURL: import.meta.env.VITE_REGGIE_URL,
});

export const quentinClient = axios.create(baseAxiosConfig);
